import Vue from 'vue'
import Vuex from 'vuex'
import vuetify from '@/plugins/vuetify'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuex)
const firebase = require('@/firebaseConfig.js')

export default new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    profileImageUrl: null,
    todos: [],
    authenticated: false,
    listenerUnsubscribe: null,
  },
  mutations: {
    SET_LISTENER_UNSUBSCRIBE(state, val) {
      state.listenerUnsubscribe = val
    },
    RESET_STORE(state) {
      vuetify.framework.theme.themes.light.primary = colors.blue.darken2
      vuetify.framework.theme.themes.dark.primary = colors.blue.lighten2
      vuetify.framework.theme.dark = false
      state.currentUser = null
      state.userProfile = {}
      state.todos = []
      state.authenticated = false
      if (state.listenerUnsubscribe) {
        state.listenerUnsubscribe()
        state.listenerUnsubscribe = null
      }
    },
    SET_CURRENT_USER(state, val) {
      state.currentUser = val
    },
    SET_USER_PROFILE(state, val) {
      state.userProfile = val
    },
    SET_THEME_COLOR(state, val) {
      const colorArray = Object.entries(colors).slice(0, 18)
      const colorByHex = Object.fromEntries(
        colorArray.map(([name, color]) => [color.base, name])
      )

      const colorName = colors[val] ? val : colorByHex[val]
      const color = colors[colorName] || colors.blue
      const theme = vuetify.framework.theme.themes

      theme.light.primary = color.darken2
      theme.dark.primary = color.lighten2
    },
    SET_TODOS(state, val) {
      state.todos = val
    },
    SET_AUTHENTICATED(state, val) {
      state.authenticated = val
    },
    SET_PROFILE_IMAGE_URL(state, val) {
      state.profileImageUrl = val
    },
    SET_DARKMODE(state, val) {
      vuetify.framework.theme.dark = val
    },
  },
  actions: {
    fetchUserProfile({ commit, state }) {
      return firebase.usersCollection
        .doc(state.currentUser.uid)
        .get()
        .then((res) => {
          const profile = {
            title: '',
            name: '',
            favoriteColor: colors.blue.base,
            profileImageUrl: null,
            darkMode: false,
            cubeCount: 0,
            soundsEnabled: true,
            ...res.data(),
          }

          if (colors[profile.favoriteColor]) {
            profile.favoriteColor = colors[profile.favoriteColor].base
          }

          commit('SET_USER_PROFILE', profile)
          commit('SET_PROFILE_IMAGE_URL', profile.profileImageUrl)
          commit('SET_THEME_COLOR', profile.favoriteColor)
          commit('SET_DARKMODE', profile.darkMode)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    firebaseLogout({ commit }) {
      commit('RESET_STORE')
      firebase.auth.signOut()
    },
    editTodo({ state }, payload) {
      // Complete = 1 cube, Complete a starred task = 2 cube
      let key = payload.key
      let value = payload.value
      let todos = firebase.usersCollection
        .doc(state.currentUser.uid)
        .collection('todos')
      todos.doc(payload.id).update(payload.key, payload.value)
      let todo = state.todos.find((x) => x.id === payload.id)
      let numCubes = todo.starred ? 2 : 1
      if (key === 'completed') {
        firebase.usersCollection.doc(state.currentUser.uid).update({
          cubeCount: value
            ? (state.userProfile.cubeCount += numCubes)
            : (state.userProfile.cubeCount -= numCubes),
        })
      }
    },
    addTodo({ state }, payload) {
      payload.createdAt = new Date()
      firebase.usersCollection
        .doc(state.currentUser.uid)
        .collection('todos')
        .add(payload)
        .catch((err) => console.log(err))
    },
    clearDeleted({ state }) {
      let deleted = firebase.usersCollection
        .doc(state.currentUser.uid)
        .collection('todos')
        .where('deleted', '==', true)
      deleted.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          doc.ref.delete()
        })
      })
    },
  },
  getters: {
    // all todos that have been completed that aren't deleted
    completedTodos: (state) => {
      return state.todos.filter((todo) => todo.completed && !todo.deleted)
    },
    // all todos that are not completed or deleted
    incompleteTodos: (state) => {
      return state.todos.filter((todo) => !todo.completed && !todo.deleted)
    },
    // all todos that have been marked deleted
    deletedTodos: (state) => {
      return state.todos.filter((todo) => todo.deleted)
    },
    // all todos that are starred and that aren't deleted
    starredTodos: (state, getters) => {
      return getters.incompleteTodos.filter((todo) => todo.starred)
    },
    currentUser: (state) => {
      return state.currentUser
    },
    userIsAuthenticated: (state) => {
      return state.authenticated
    },
    email: (state) => {
      return state.currentUser.email
    },
    title: (state) => {
      return state.userProfile.title
    },
    name: (state) => {
      return state.userProfile.name
    },
    emailIsVerified: (state) => {
      return state.currentUser.emailVerified
    },
    uid: (state) => {
      return state.currentUser.uid
    },
    favoriteColor: (state) => {
      return state.userProfile.favoriteColor
    },
    profileImageUrl: (state) => {
      return state.profileImageUrl
    },
    darkMode: (state) => {
      return state.userProfile.darkMode
    },
    cubeCount: (state) => {
      return state.userProfile.cubeCount
    },
    soundsEnabled: (state) => {
      return state.userProfile.soundsEnabled === undefined
        ? true
        : state.userProfile.soundsEnabled
    },
  },
})
